import { defineStore } from 'pinia'

type ChatState = {
  userId: string | undefined
  token: string | undefined
  unreadCount: number
}

export const useChatStore = defineStore('chat', {
  actions: {
    setToken(token: string) {
      this.token = token
    },
    setUnreadCount(unreadCount: number) {
      this.unreadCount = unreadCount
    },
    setUserId(userId: string) {
      this.userId = userId
    },
  },
  state: (): ChatState => ({
    token: undefined,
    unreadCount: 0,
    userId: undefined,
  }),
})
